/* eslint-disable react/jsx-no-useless-fragment */
import Image from 'next/image'
import styles2 from './fastagModal.module.scss'
import BankListShimmer from './bankListShimmer'
import { BANK_LOGO, FASTAG_NOT_FOUND } from './constants'

interface Bank {
  biller_details_id: string
  name: string
  icon_url: string
}

interface BankListProps {
  filteredBanks: Bank[]
  selectedBank: Bank | null
  handleClick: (bank: Bank) => void
  isFetchingProvider: boolean
}

const BankList = ({ filteredBanks, selectedBank, handleClick, isFetchingProvider }: BankListProps) =>
  isFetchingProvider ? <BankListShimmer /> : filteredBanks?.length ? (
  <>
  {filteredBanks?.map(bank => (
        <div
          key={bank?.biller_details_id}
          className={`${styles2.bankDiv} ${selectedBank === bank ? styles2.selected : ''}`}
          onClick={() => handleClick(bank)}>
          <span>
            <Image src={bank?.icon_url} width={30} height={30} alt={BANK_LOGO} />
          </span>
          {bank?.name}
        </div>
      ))}
    </>
  ) : (
    <div className={styles2.noBankFound}>{FASTAG_NOT_FOUND}</div>
  )

export default BankList
